import React from 'react';
import { Header } from 'components';
import { CssBaseline } from '@mui/material';
import { Main } from './main';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import 'react-toastify/dist/ReactToastify.css';
import { themeSettings } from 'theme';

export const App = () => {
  const theme = createTheme(themeSettings('light'));

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Header />
      <Main />
      <ToastContainer />
    </ThemeProvider>
  );
};
